import React from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import InputText from "../../input/inputText";
import {
  removeErrorField,
  setErrorMessage,
  setIsScanLimits,
  setUniqueScans,
} from "../../../redux/slices/settings";
import { useDispatch, useSelector } from "react-redux";
import { InfoIcon } from "./../svg";

const ScanLimits = () => {
  const {
    isScanLimits,
    uniqueScans,
    errorMessage,
    lang,
    errorFields,
    errorLang,
  } = useSelector((state) => ({
    isScanLimits: state.settings.scanLimits.isScanLimits,
    uniqueScans: state.settings.scanLimits.uniqueScans,
    errorMessage: state.settings.scanLimits.errorMessage,
    lang: state.changeLang.language.restriction,
    errorFields: state.settings.errorFields,
    errorLang: state.changeLang.language.stepTwo.errors,
  }));
  const dispatch = useDispatch();

  const handleUniqueScans = (e) => {
    const value = e.target.value;
    dispatch(setUniqueScans(value));
    if (value.length) {
      dispatch(removeErrorField("uniqueScans"));
    }
  };

  return (
    <div className="mb-4">
      <div>
        <Form.Check
          type="checkbox"
          label={lang[0]}
          checked={isScanLimits}
          onChange={() => dispatch(setIsScanLimits(!isScanLimits))}
          id="scanLimits`"
          className="me-2 d-inline-block fw-bold"
        />
        <OverlayTrigger
          overlay={<Tooltip className="opacity-75">{lang[1]}</Tooltip>}
        >
          <div className="d-inline">
            <InfoIcon className="mb-1" />
          </div>
        </OverlayTrigger>
      </div>

      {isScanLimits && (
        <Row className="g-3 mt-0">
          <Col xs={12} md={4}>
            <InputText
              placeholder={lang[2]}
              type="number"
              value={uniqueScans}
              min={0}
              onKeyDown={(e) =>
                ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
              }
              onChange={handleUniqueScans}
              popoverText={null}
              className="mb-0"
              name="uniqueScans"
              error={errorFields.includes("uniqueScans")}
            />
            {errorFields.includes("uniqueScans") && (
              <div className="text-danger">{errorLang[4]}</div>
            )}
          </Col>
          <Col xs={12} md={8}>
            <InputText
              placeholder={lang[3]}
              value={errorMessage}
              onChange={(e) => dispatch(setErrorMessage(e.target.value))}
              popoverText={null}
              className="mb-0"
              maxLength="255"
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default ScanLimits;
